import React, { useState, useEffect, useContext } from 'react';
import { reservedTextStyle, reservedTimeStyle } from '../Campaign/AirtimePlanning/AirtimePlanningStyles';
// import { dateAppliedTimezone } from '../../services/UtilsService';
import { SystemSettingsContext } from '../../contexts/SystemSettingsContext';
import moment from 'moment';

const ReservationTimer = ({
    data,
    reservedUntil,
    reservationsTab = false,
    stopTicking = false,
    isMounted = false,
    isReserved,
    setIsReserved,
    planExpired,
    setPlanExpired,
    runningNewPlan,
    setRunningNewPlan
}) => {
    const { dateFormat } = useContext(SystemSettingsContext);
    const [reservedFor, setReservedFor] = useState('');
    const [reservedColor, setReservedColor] = useState('#199001');
    const [fontSize, setFontSize] = useState(14);
    const [dataReservedUntil, setDataReservedUntil] = useState(null);

    useEffect(() => {
        countDown();
    }, [reservedUntil, dataReservedUntil]);

    useEffect(() => {
        const dataDate = new Date(data?.reservedUntil);
        setDataReservedUntil(dataDate);
    }, [data?.reservedUntil]);

    const updateStatuses = () => {
        if ((reservationsTab && !dataReservedUntil) || (!reservationsTab && (!reservedUntil || !isMounted))) {
            if (setRunningNewPlan && runningNewPlan) setRunningNewPlan(false);
            return;
        }
        const dt = new Date();
        // TODO once DateTime issue with TimeZone is fixed dateAppliedTimezone needs to be removed
        // const expiryDateTime = dateAppliedTimezone(reservedUntil);
        const expiryDateTime = reservationsTab ? dataReservedUntil : new Date(reservedUntil);
        const remaining = (expiryDateTime - dt) / 1000;
        if (setIsReserved && isReserved !== remaining > 0) setIsReserved(remaining > 0);

        if (remaining <= 0) {
            if (setIsReserved && isReserved) setIsReserved(false);
            if (setPlanExpired && !planExpired) setPlanExpired(true);
        } else {
            if (setIsReserved && !isReserved) setIsReserved(true);
            if (planExpired && setPlanExpired) setPlanExpired(false);
        }
    };

    const countDown = () => {
        const dt = new Date();
        // TODO once DateTime issue with TimeZone is fixed dateAppliedTimezone needs to be removed
        // const ru = dateAppliedTimezone(reservedUntil);
        const ru = reservationsTab ? dataReservedUntil : new Date(reservedUntil);
        let remaining = (ru - dt) / 1000;
        if (remaining < 0 || isNaN(remaining)) {
            const reservedStr = reservationsTab ? window.translate('Expired') : '';
            if (reservedFor !== reservedStr) setReservedFor(reservedStr);
            if (reservedColor !== '#DB0000') setReservedColor('#DB0000');
            updateStatuses();
            return false;
        }
        let hrs = Math.floor(remaining / 3600);
        const days = Math.floor(hrs / 24);
        remaining -= hrs * 3600;
        hrs -= days * 24;

        let mins = Math.floor(remaining / 60);
        let secs = Math.floor(remaining - mins * 60);
        if (secs < 10) secs = '0' + secs;
        if (mins < 10) mins = '0' + mins;
        if (hrs < 10) hrs = '0' + hrs;
        if (remaining <= 0 || isNaN(remaining)) {
            return false;
        } else if (!reservationsTab) {
            const reservedStr =
                days > 0
                    ? `${days} ${window.translate(days === 1 ? 'day' : 'days')} ${hrs}:${mins}:${secs}`
                    : hrs > 0
                        ? `${hrs}:${mins}:${secs}`
                        : `${mins}:${secs}`;
            if (reservedFor !== reservedStr) setReservedFor(reservedStr);

            const reservedColorString = days > 0 || hrs > 0 || mins > 19 ? '#199001' : mins > 9 ? '#F18401' : '#DB0000';
            if (reservedColor !== reservedColorString) setReservedColor(reservedColorString);
        } else {
            const reservedStr =
                days > 0 ? moment(ru).format(dateFormat) : hrs > 0 ? `${hrs}:${mins}:${secs}` : `${mins}:${secs} mins`;
            if (reservedFor !== reservedStr) setReservedFor(reservedStr);
            const fSize = days > 0 ? 14 : 18;
            if (fSize !== fontSize) setFontSize(fSize);
            const reservedColorString =
                days > 0 || hrs > 0 ? '#414141' : mins > 19 ? '#199001' : mins > 9 ? '#F18401' : '#DB0000';
            if (reservedColor !== reservedColorString) setReservedColor(reservedColorString);
        }
        updateStatuses();
        return true;
    };

    const clockTick = () => {
        if (stopTicking || (reservationsTab && !dataReservedUntil) || (!reservationsTab && !reservedUntil)) {
            clearInterval(myInterval);
            return;
        }

        if (!countDown()) {
            clearInterval(myInterval);
        }
    };
    let myInterval;
    useEffect(() => {
        myInterval = setInterval(clockTick, 1000);
        return () => {
            clearInterval(myInterval);
        };
    }, [reservedUntil]);

    return (
        <>
            {!reservationsTab && reservedFor !== '' ? (
                <span style={reservedTextStyle(reservedColor)}>
                    {window.translate('Reserved for')}
                    &nbsp;
                    <span style={reservedTimeStyle(reservedColor)}>{reservedFor}</span>
                </span>
            ) : (
                <span
                    style={{
                        ...reservedTimeStyle(reservedColor),
                        fontSize: fontSize
                    }}
                >
                    {reservedFor}
                </span>
            )}
        </>
    );
};

export default ReservationTimer;
